import React from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import Style from "./Videos_SubScription.module.css";
import axios from "axios";
import { useQuery } from "react-query";
import { BallTriangle } from "react-loader-spinner";
import { toast } from "react-toastify";

const VideosSubScription = () => {
  const notify = (mess, type) => {
    toast[type](mess);
  };
  let { name, courseId, subjectId, subjectname } = useParams();
  function getvideos() {
    return axios.get(
      `https://itc-541ea27f6158.herokuapp.com/api/v1/subject-video/subject/${subjectId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      }
    );
  }
  let { isFetching, isLoading, isError, data } = useQuery(
    "featuredVideos",
    getvideos,
    {
      cacheTime: 100,
    }
  );

  return (
    <>
      <Helmet>
        <title>الفيديوهات</title>
      </Helmet>

      {isLoading ? (
        <>
          <div className={`${Style.home2} w-full flex justify-center`}>
            <BallTriangle
              height={100}
              width={100}
              radius={5}
              color="#4fa94d"
              ariaLabel="ball-triangle-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        </>
      ) : (
        <>
          <div
            className={`${Style.home} bg-gray-100 min-h-screen  W-FULL   rounded-tr-3xl    `}
          >
            <div className="  flex items-center bg-white p-5 rounded-xl my-5">
              <div className="flex items-center">
                <Link to={"/"} className="mr-2 text-green-500">
                  {name}
                </Link>
              </div>
              <div className="flex items-end pt-1">
                <span className="px-2">
                  <svg
                    width="9"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.85398 0.319999V2.3L2.67398 5.36L8.85398 8.06V10.02L0.173984 6.04V4.84L8.85398 0.319999Z"
                      fill="#009539"
                      fillOpacity="0.7"
                    />
                  </svg>
                </span>
              </div>
              <Link
                to={`/${name}/${courseId}/subjects`}
                className="font-bold text-green-600"
              >
                {subjectname}
              </Link>
              <div className="flex items-end pt-1">
                <span className="px-2">
                  <svg
                    width="9"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.85398 0.319999V2.3L2.67398 5.36L8.85398 8.06V10.02L0.173984 6.04V4.84L8.85398 0.319999Z"
                      fill="#009539"
                      fillOpacity="0.7"
                    />
                  </svg>
                </span>
              </div>
              <Link to={"/vedios"} className="font-bold text-green-600">
                الفيديوهات
              </Link>
            </div>

            <div
              className={`  grid  gap-3 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2  sm:grid-cols-2 `}
            >
              {data?.data.data.map((video) => {
                return (
                  <>
                    <div key={video.videoId}>
                      <Link
                        to={`/My_subscriptions/${name}/${courseId}/VideoDetails/${video.videoId}`}
                        className={`block p-4 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 `}
                      >
                        <div className="flex items-center justify-between pt-0">
                          <h5 className="mb-2 text-lg font-bold tracking-tight text-gray-900 ">
                            {video?.videoTitle}
                          </h5>
                          <svg
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.1627 0L22 2.01717L9.69779 20H6.86044L0 10.2575L2.83734 7.57511L8.27911 12.7253L19.1627 0Z"
                              fill="#32AA2F"
                            />
                          </svg>
                        </div>

                        <h5 className="text-lg tracking-tight text-green-500 overflow-hidden whitespace-nowrap truncate">
                          {video?.videoDescription.slice(0, 40)}
                        </h5>
                        <div className="flex items-center justify-between pt-0">
                          <div></div>
                          <svg
                            width="38"
                            height="38"
                            viewBox="0 0 38 38"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M12.0688 6.06C14.3739 5.8448 16.6863 5.73379 19 5.72727C21.3813 5.72727 23.7323 5.86091 25.9312 6.06C28.576 6.3 30.2885 6.46364 31.5957 6.79636C32.7864 7.09909 33.4527 7.5 34.0252 8.13C34.086 8.19818 34.1772 8.30182 34.2329 8.37545C34.7396 9.00273 35.0689 9.78818 35.2589 11.2718C35.4616 12.8618 35.4667 14.9345 35.4667 18.0682C35.4667 21.1636 35.4616 23.2091 35.2589 24.7773C35.0715 26.2391 34.7421 27.0164 34.2329 27.6518C34.1649 27.7357 34.0948 27.8175 34.0227 27.8973C33.44 28.5355 32.7813 28.9309 31.6211 29.2255C30.3367 29.5527 28.6621 29.7109 26.0629 29.9455C23.8615 30.1418 21.4725 30.2727 19 30.2727C16.5275 30.2727 14.136 30.1418 11.9371 29.9455C9.33787 29.7109 7.66333 29.5527 6.37893 29.2255C5.21613 28.9309 4.55747 28.5355 3.97733 27.8973C3.90523 27.8175 3.83512 27.7356 3.76707 27.6518C3.2604 27.0164 2.93107 26.2391 2.74107 24.7773C2.5384 23.2091 2.53333 21.1636 2.53333 18.0682C2.53333 14.9345 2.5384 12.8591 2.74107 11.2718C2.93107 9.78818 3.2604 9.00273 3.76707 8.37545C3.82533 8.30182 3.914 8.19818 3.9748 8.13C4.54733 7.5 5.2136 7.09909 6.40427 6.79636C7.714 6.46364 9.424 6.3 12.0688 6.06ZM0 18.0682C0 11.9536 0 8.89636 1.84933 6.59182C1.94053 6.47727 2.06467 6.33273 2.16347 6.22364C4.13947 4.04455 6.71333 3.81 11.856 3.34364C14.1107 3.13636 16.5351 3 19 3C21.4649 3 23.8893 3.13636 26.144 3.34364C31.2867 3.81 33.8605 4.04455 35.8365 6.22364C35.9353 6.33273 36.0569 6.47727 36.1507 6.59182C38 8.89636 38 11.9536 38 18.0682C38 24.1091 38 27.1309 36.1481 29.4355C36.0458 29.5614 35.9402 29.6842 35.8315 29.8036C33.8529 31.9827 31.3272 32.2091 26.2732 32.6618C24.016 32.8664 21.5536 33 19 33C16.4464 33 13.984 32.8636 11.7293 32.6618C6.6728 32.2091 4.14707 31.98 2.16853 29.8036C2.05983 29.6841 1.95424 29.5613 1.85187 29.4355C0 27.1309 0 24.1091 0 18.0682ZM13.3 12.2264C13.2996 12.113 13.3256 12.0012 13.3754 11.9013C13.4253 11.8014 13.4975 11.7165 13.5855 11.6542C13.6736 11.5919 13.7746 11.5542 13.8796 11.5446C13.9846 11.535 14.0901 11.5537 14.1867 11.5991L26.4176 17.3755C26.9243 17.6155 26.9243 18.3845 26.4176 18.6245L14.1867 24.3982C14.0903 24.4435 13.985 24.4622 13.8802 24.4527C13.7755 24.4432 13.6746 24.4058 13.5866 24.3438C13.4986 24.2819 13.4263 24.1973 13.3763 24.0977C13.3263 23.9982 13.3001 23.8868 13.3 23.7736V12.2264Z"
                              fill="#01943A"
                            />
                          </svg>
                        </div>
                      </Link>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default VideosSubScription;
